<template>
  <div>
    <b-row class="mb-5">
      <b-col cols="12">
        <div style="overflow:auto">
          <spinner v-if="activateSpinner"></spinner>
          <b-table v-else-if="listItemsEntityAccountFile.length > 0"
            :items="listItemsEntityAccountFile"
            :fields="fields"
            class="table-striped"
            hover
            :selectable="listItemsEntityAccountFile.length > 0"
            :empty-text="$t('common.security.no_result')"
            style="margin-bottom:0"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDir"
            @head-clicked="sortTable"
            @row-selected="handleRowClicked"
            :key="refreshKey">
            <template #cell(DateStartImport)="data">
              <span v-if="data.value !== ''">{{ getDate(data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(FileName)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(FileReference)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(Bic)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(Status)="data">
              <span v-if="data.value !== ''">{{ $t('common.entity_account.file_status_' + data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(SynchroType)="data">
              <span v-if="data.value !== ''">{{ $t('common.entity_account.synchro_type_' + data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(ImportResult)="data">
              <span v-if="data.value !== ''">{{ $t('common.entity_account.import_result_' + data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(NbOK)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(NbKO)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(NumberLinesProcessed)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
          </b-table>
          <div v-else class="d-flex justify-content-center">
            <span class="noResult">
              {{ $t('common.no_result') }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <cm-pagination v-if="!flagCACP"
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>

        <cm-pagination-entity-cacp v-else
                                     :maxResultsByPage="paginationObject.maxResults"
                                     :firstIndex="paginationObject.firstIndex"
                                     :nbResultsTotal="paginationObject.nbResultsTotal"
                                     :refreshEvent="paginationObject.refresh"
                                   @directInboxFiltered="getEntityAccountFile($event)"
                                     :has-next="paginationObject.hasNext">
        </cm-pagination-entity-cacp>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment-timezone'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import PaginationEntityAccount from "@/components/common/paginationEntityAccount.vue";
import conf from "@/config/config.dev";
import _ from "lodash";

export default {
  name: "EntityAccountFileList",
  components: {
    'cm-pagination-entity-cacp': PaginationEntityAccount,
    'cm-pagination': Pagination,
    'datetime-picker-custom': dateTimePicker,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      timezone: '+00:00',
      EntityAccountListAll: {
        data:[],
        pagination:[]
      },
      flagCACP: conf.visual === 'CACP',
      flagBPCE: conf.visual === 'BPCE',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      lastDate: '',
      activateSpinner: false,
      filterConditions: {},
      listItemsEntityAccountFile: [],
      listTitle: "",
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false
    }
  },
  created() {
    this.timezone = moment.tz.guess()

    const queryParams = this.$route.query

    if (queryParams.firstIndex) {
      this.paginationObject['firstIndex'] = queryParams.firstIndex
    } else {
      this.paginationObject['firstIndex'] = 1
    }
    if (queryParams.OrderByField) {
      this.filterConditions.OrderByField = queryParams.OrderByField
    }
    if (queryParams.OrderByDirection) {
      this.filterConditions.OrderByDirection = queryParams.OrderByDirection
    }
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    this.listTitle = this.$i18n.t("common.entity_account.entity_account_file")
    this.activateSpinner = true
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.off('direct-inbox-filtered')
    this.$bus.on('direct-inbox-filtered', index => {
      this.getEntityAccountFile(index)
    })

    // Événements pour contrôle depuis EntityAccountPage
    this.$bus.$off('refresh-entity-file')
    this.$bus.$on('refresh-entity-file', () => {
      this.onRefresh()
    })

    // Gestion des filtres depuis le parent
    this.$bus.$off('apply-filters-entity-file')
    this.$bus.$on('apply-filters-entity-file', (filters) => {
      this.filterConditions = filters
      this.onRefresh()
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    if (queryParams.firstIndex > 1) {
      this.getEntityAccountFile(this.paginationObject['firstIndex'])
    } else {
      this.getEntityAccountFile()
    }

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'DateStartImport',
        label: this.$t('common.entity_account.date_start_import'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'FileName',
        label: this.$t('common.entity_account.file_name'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'FileReference',
        label: this.$t('common.entity_account.file_reference'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'Bic',
        label: this.$t('common.entity_account.bic'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'Status',
        label: this.$t('common.entity_account.file_status'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'SynchroType',
        label: this.$t('common.entity_account.synchro_type'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'ImportResult',
        label: this.$t('common.entity_account.import_result'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'NbOK',
        label: this.$t('common.entity_account.nb_iban_processed'),
        class: 'text-center',
        sortable: false
      })
      fields.push({
        key: 'NbKO',
        label: this.$t('common.entity_account.nb_iban_rejected'),
        class: 'text-center',
        sortable: false
      })
      fields.push({
        key: 'NumberLinesProcessed',
        label: this.$t('common.entity_account.nb_lines_processed'),
        class: 'text-center',
        sortable: false
      })
      return fields
    }
  },
  methods: {
    applyFilter(filterConditions = {}) {
      if (this.flagCACP) {
        this.EntityAccountListAll = {
          data:[],
          pagination:[]
        }
      }
      this.lastUUID = ''
      this.lastDate = ''
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getEntityAccountFile()
    },
    canViewDetails () {
      return this.$engine.firstOn().rights.rightIs('entityAccount_consult', true)
    },
    async fetchEntityAccountAndMerge (filterConditions, index) {
      let that = this
      let requests = []
      let listEngineDownLocal = []



      for (let i = 0; i < that.$engine.engines.length; i++) {

        const engine = that.$engine.get(i)
        if (engine.common.network.state === 'offline') {
          continue
        }

        if (engine?.entityAccount?.getEntityAccountFile) {
          try {
            const resp = await engine.entityAccount.getEntityAccountFile(filterConditions)

            if (that.flagCACP) {
              if (resp?.data?.EntityAccountFile?.length){
                that.lastDate = moment(resp.data.EntityAccountFile[resp.data.EntityAccountFile.length - 1].LastDateHistory , 'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYY-MM-DD HH:mm:ss.SSS')
                that.lastUUID = resp.data.EntityAccountFile[resp.data.EntityAccountFile.length - 1].RandomUuid
              }
            }

            if (index == 1 && i == 0){
              that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
            }

            if(resp.data.nbTotalResults){
              if (index == 1 && i != 0){
                that.paginationObject.nbResultsTotal += resp.data.nbTotalResults
              }
              if(!that.EntityAccountListAll.data[index]){
                that.paginationObject.firstIndex = index
                that.EntityAccountListAll.pagination[index] = _.cloneDeep(that.paginationObject)
              }
            }

            // Ajoute engineIndex à chaque item
            const taggedEntityAccount = resp.data.EntityAccountFile.map(item => ({
              ...item,
              engineIndex: i
            }))
            requests.push(...taggedEntityAccount)

          } catch (error) {
            errorMessageAlert(error, that)
          }
        }
      }

      if (requests.length == 0){
        this.listItemsEntityAccountFile = []
        this.activateSpinner = false
      }
      else{
        this.engineDown = {
          host: 'server-prod-01',
          error: 'HTTP 500 – Internal Server Error'
        }

        //Pas assez de donnée pour une nouvelle page
        if(that.paginationObject.maxResults + 1 > requests.length) {
          that.EntityAccountListAll.pagination[index].hasNext = false;
          that.paginationObject.hasNext = false;
        }
        else{
          that.EntityAccountListAll.pagination[index].hasNext = true;
          that.paginationObject.hasNext = true;
        }

        if (listEngineDownLocal.length === this.$engine.length) {
          errorMessageAlert(listEngineDownLocal[0].error, this)
        } else {
          const sortedRequests = requests.slice().sort((a, b) => {
            // Comparaison sur LastDateHistory (descendant)
            const dateDiff = new Date(b.LastDateHistory) - new Date(a.LastDateHistory);
            if (dateDiff !== 0) {
              return dateDiff;
            }

            // Si égalité → tri sur RandomUuid (ascendant)
            if (a.RandomUuid < b.RandomUuid) return -1;
            if (a.RandomUuid > b.RandomUuid) return 1;
            return 0;
          }).slice(0, this.paginationObject['maxResults'])


          if (this.flagCACP) {
            if (sortedRequests?.length){
              for (let i = sortedRequests.length - 1; i >= 0; i--) {
                const date = sortedRequests[i].LastDateHistory;
                if (date) {
                  this.lastDate = date
                  this.lastUUID = sortedRequests[i].RandomUuid
                  break;
                }
              }
            }
          }


          this.updateEntityAccountFile(sortedRequests)

          if (this.flagCACP) {
            this.EntityAccountListAll.data[index] = sortedRequests
          }

          this.activateSpinner = false
        }
        this.listEngineDown = listEngineDownLocal
      }
    },
    getEntityAccountFile (index = 1) {
      let that = this

      if (that.EntityAccountListAll.data[index] && that.flagCACP) {
        that.listItemsEntityAccountFile = _.cloneDeep(that.EntityAccountListAll.data[index])
        that.paginationObject = _.cloneDeep(that.EntityAccountListAll.pagination[index])
        return
      }else{
        let params = {
          FileName: that.filterConditions.filename || '',
          FileReference: that.filterConditions.fileReference || '',
          dateBegin: that.filterConditions.startDate ? moment.tz(that.filterConditions.startDate, 'DD/MM/YYYY HH:mm:ss', that.timezone).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
          dateEnd: that.filterConditions.endDate ? moment.tz(that.filterConditions.endDate, 'DD/MM/YYYY HH:mm:ss', that.timezone).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
          Status: that.filterConditions.fileStatus || '',
          SynchroType: that.filterConditions.fileType || '',
          maxResults: that.paginationObject.maxResults,
          firstIndex: index,
        }

        // Désactivation du paramètre dateEndHistory qui limitait les résultats en mode CACP
        if (that.flagCACP && that.lastDate != '') {
          params.dateEndHistory = moment.parseZone(that.lastDate).subtract(1, 'milliseconds').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
          params.RandomUuid = that.lastUUID
        }
        if (that.filterConditions.OrderByField) {
          params.OrderByField = that.filterConditions.OrderByField
        }
        if (that.filterConditions.OrderByDirection) {
          params.OrderByDirection = that.filterConditions.OrderByDirection
        }
        that.fetchEntityAccountAndMerge(params, index)
      }


    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    handleRowClicked (item) {
      if (this.canViewDetails()) {
        this.onRowClicked(item)
      }
    },
    onRefresh() {
      if (this.flagCACP) {
        if(this.listItemsEntityAccountFile.length > 0){
          this.$refs.entityAccountPagination.resetPaginationCACP()
        }
        this.EntityAccountListAll = {
          data:[],
          pagination:[]
        }
      }
      this.lastDate = ''
      this.lastUUID = ''
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEntityAccountFile()
    },
    onRowClicked (item) {
      if (item?.[0]?.IdEntityAccountFile) {
          const params = {}
          if (this.filterConditions.filename) params.FileName = this.filterConditions.filename
          if (this.filterConditions.fileReference) params.FileReference = this.filterConditions.fileReference
          if (this.filterConditions.startDate) params.dateBegin = this.filterConditions.startDate
          if (this.filterConditions.endDate) params.dateEnd = this.filterConditions.endDate
          if (this.filterConditions.fileStatus) params.Status = this.filterConditions.fileStatus
          if (this.filterConditions.fileType) params.SynchroType = this.filterConditions.fileType
          if (this.paginationObject.maxResults !== '') params.maxResults = this.paginationObject.maxResults
          if (this.paginationObject.firstIndex !== '') params.firstIndex = this.paginationObject.firstIndex

          if (this.filterConditions.OrderByField) {
              params.OrderByField = this.filterConditions.OrderByField
          }
          if (this.filterConditions.OrderByDirection) {
              params.OrderByDirection = this.filterConditions.OrderByDirection
          }

          params.idEngine = item[0].engineIndex
          if (Object.keys(params).length > 0) {
              const queryParams = new URLSearchParams(params).toString()
              loadPage(this, { url: `/entityAccountFile/details/${item[0].engineIndex}/${item[0].IdEntityAccountFile}?${queryParams}` })
          }
      }
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'FileName',
        'FileReference',
        'DateStartImport',
        'Status',
        'SynchroType',
        'ImportResult',
        'Bic'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateEntityAccountFile(EntityAccountFileList) {
      this.listItemsEntityAccountFile = EntityAccountFileList
    }
  }
}
</script>

<style scoped>
/* Fix table header contrast issues - remove all background images */
::v-deep .table th {
  background-color: #f8f9fa !important;
  background-image: none !important;
  color: #495057 !important;
  border-color: #dee2e6 !important;
}

::v-deep .table th[aria-sort] {
  background-color: #f8f9fa !important;
  background-image: none !important;
  color: #495057 !important;
  position: relative;
}

::v-deep .table th[aria-sort]::before,
::v-deep .table th[aria-sort]::after {
  background: none !important;
  background-image: none !important;
  color: #495057 !important;
  content: '' !important;
}

/* Remove any Bootstrap Vue sorting images */
::v-deep .table thead th.sortable {
  background-image: none !important;
  color: #495057 !important;
}

::v-deep .table thead th.sortable:hover {
  background-color: #e9ecef !important;
  background-image: none !important;
  color: #212529 !important;
}

/* Remove sorting indicator divs that might contain images */
::v-deep .table th div {
  background: transparent !important;
  background-image: none !important;
}
</style>
